import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from '../assets/logo.png'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="bg-secondary/50 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-[72px] items-center">
          <Link to="/" className="flex items-center gap-1">
            <div className="rounded-lg">
              <img src={logo} alt="logo" className="w-12 h-auto" />
            </div>
            <span className="text-2xl font-bold text-primary tracking-tight">
              MALDROID
            </span>
          </Link>

          <div className="hidden md:flex space-x-8">
            <Link
              to="/"
              className="text-primary hover:text-secondary font-medium transition-colors"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-primary hover:text-secondary font-medium transition-colors"
            >
              About Us
            </Link>
            <Link
              to="/contact"
              className="text-primary hover:text-secondary font-medium transition-colors"
            >
              Contact Us
            </Link>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-600 hover:text-primary"
            >
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-b"
          >
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/"
                className="block px-3 py-2 text-gray-600 hover:text-primary"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block px-3 py-2 text-gray-600 hover:text-primary"
                onClick={() => setIsOpen(false)}
              >
                About Us
              </Link>
              {/* <Link
                to="/policy"
                className="block px-3 py-2 text-gray-600 hover:text-primary"
                onClick={() => setIsOpen(false)}
              >
                Privacy
              </Link> */}
              <Link
                to="/contact"
                className="block px-3 py-2 text-gray-600 hover:text-primary"
                onClick={() => setIsOpen(false)}
              >
                Contact
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
